<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import DefaultLayout from "./layouts/Default.vue";
const route = useRoute();

const layouts = {
  DefaultLayout,
};

const layout = computed(() => layouts[route.meta.layout] || DefaultLayout);
</script>

<template>
  <component :is="layout">
    <router-view />
  </component>
</template>
